module.exports = __webpack_public_path__ + "img/form-title.13d3ed05.png";